var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOujatProtection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 13.0471V9.66026C24.5 7.74692 24.5 6.79025 24.0285 6.16609C23.5571 5.54192 22.4911 5.23891 20.3592 4.63287C18.9026 4.21882 17.6185 3.71999 16.5927 3.26459C15.194 2.6437 14.4947 2.33325 14 2.33325C13.5053 2.33325 12.806 2.6437 11.4073 3.26459C10.3815 3.71999 9.09748 4.21881 7.64089 4.63287C5.50892 5.23891 4.44292 5.54192 3.97146 6.16609C3.5 6.79025 3.5 7.74692 3.5 9.66026V13.0471C3.5 19.6098 9.40656 23.5473 12.3597 25.1059C13.0679 25.4797 13.422 25.6666 14 25.6666C14.578 25.6666 14.932 25.4797 15.6403 25.1059C18.5934 23.5473 24.5 19.6098 24.5 13.0471Z",
    stroke: "#8F9DAC",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9166 13.4167C16.9166 15.0275 15.6108 16.3333 14 16.3333C12.3892 16.3333 11.0833 15.0275 11.0833 13.4167C11.0833 11.8059 12.3892 10.5 14 10.5C15.6108 10.5 16.9166 11.8059 16.9166 13.4167Z",
    stroke: "#8F9DAC",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOujatProtection);
export default __webpack_public_path__ + "static/media/Oujat-Protection.c0afea11f340136636ad32b9781be5b1.svg";
export { ForwardRef as ReactComponent };